/**
 * Escapes special regex characters in a string to make it safe for use in RegExp constructor.
 * Only escapes actual RegExp metacharacters: . * + ? ^ $ { } ( ) | [ ] \ /
 *
 * @param text - The string to escape
 * @returns The escaped string safe for regex patterns (including Unicode flag)
 *
 * @example
 * escapeRegex('hello.world') // 'hello\\.world'
 * escapeRegex('$100 (USD)') // '\\$100 \\(USD\\)'
 */
export const escapeRegex = (text: string): string =>
  text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
